<!-- 报警内容详细 -->
<template>
  <modal :visible.sync='visible' :title="$t('integration.event_information')" append-to-body width='700px'>
    <div class='pd-10' v-if='detail'>
      <el-form label-width='140px'>
        <el-form-item :label="$t('integration.company')">{{ detail.sceneName }}</el-form-item>

        <el-form-item :label="$t('integration.monitoring_point')">
          <i v-icon="['carrierTypeConvert', detail.type + 1]"></i>
          {{ detail.carrierName }}
        </el-form-item>

        <el-form-item :label="$t('integration.type')">
          <AlarmReason :row='detail' style='width: 100px;'></AlarmReason>
          <!-- <div class="ex-data-tag" style="width: 100px;">{{ detail.alarmReason }}</div> -->
        </el-form-item>

        <el-form-item :label="$t('integration.event')">
          <template v-if='exContentList.length'>
            <div>
              <div class='border' v-for='item in exContentList' :key='item.id'>
                <div class='bg-theme color-white uk-text-center'>{{ item.carrierDeviceName }}</div>
                <div style='height: 100px;overflow-y:auto'>
                  <div class='uk-flex uk-flex-between pl-5 pr-5' :key='ex.id'
                       v-for='ex in item.recordDetails'>
                    <div>{{ $timetransition(ex.recordTime) }}</div>
                    <div v-if='ex.exCatalog === 1 && ex.content'>
                                            <span v-range='[ex.content.val, ex.content]'>{{ ex.content.val }}{{
                                                ex.content.unit }}</span>
                      ({{ ex.content.min }}{{ ex.content.unit }} ~ {{ ex.content.max }}{{
                        ex.content.unit }})
                    </div>
                    <div v-else-if='ex.exCatalog === 0'>
                      {{ $t('integration.monitoring_device_connection_failure') }}
                    </div>
                    <div v-else>
                      {{ $t('integration.standby_power_supply_for_device_startup') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div>{{ $t('integration.there_is_currently_no_content_available') }}</div>
          </template>
        </el-form-item>
      </el-form>
      <HandleEx ref='handleEx' :detail='detailArr' label-width='140px'></HandleEx>
    </div>
    <template #footer>
      <el-button type='primary' @click='handle'>{{ $t('integration.handle') }}</el-button>
      <!--<el-button type='primary' @click='handleWithStopAlarm'>{{ $t('integration.process_and_stop_alarms') }}</el-button>-->
    </template>
  </modal>
</template>

<script>
import HandleEx from '@/pages/abnormal/component/HandleExDia/HandleEx'
import bus from '@/utils/bus'
import { exHandle } from '@/api/modules/abnormal'
import AlarmReason from '@/config/table/widgets/AlarmReason'
import { getExContentDetail } from '@/api/modules/alarmRecord'

export default {
  components: {
    HandleEx,
    AlarmReason
  },
  computed: {
    detailArr () {
      return [this.detail]
    }
  },
  data () {
    return {
      visible: false,
      detail: null,
      exContentList: []
    }
  },
  methods: {
    // 处理异常
    async handle () {
      const { exId } = this.detail
      const params = await this.$refs.handleEx.getData()
      exHandle({
        exIds: [exId],
        process: {
          ...params
        }
      }).then(({ result }) => {
        this.visible = false
        this.$refs.handleEx.handleResult(result)
      })
    },
    // 处理并停止报警
    async handleWithStopAlarm () {
      const {
        exId,
        carrierId
      } = this.detail
      const params = await this.$refs.handleEx.getData()
      exHandle({
        carrierId: carrierId,
        exIds: [exId],
        process: {
          ...params
        }
      }).then(({ result }) => {
        this.visible = false
        this.$refs.handleEx.handleResult(result)
      })
    }
  },
  mounted () {
    bus.$on('exContentDetail', ({ detail }) => {
      this.visible = true
      this.detail = detail
      getExContentDetail(detail.id).then(({ result }) => {
        result = result.map(item => {
          item.recordDetails = item.recordDetails.map(item => {
            if (item.content) {
              item.content = JSON.parse(item.content)
            }
            return item
          })
          return item
        })
        console.log(result)

        this.exContentList = result
      })
    })
  },
  beforeDestroy () {
    bus.$off('exContentDetail')
  }
}
</script>
